import React, { useState } from 'react';
import { observer } from 'mobx-react';
import constant from '../../utils/constant';
import { QuotationController } from '../../controllers';
import { object, string, number, array, boolean, date } from 'yup';
import { invoiceStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import DuplicateQuote from '../../pages/Invoice/DuplicateQuotes';

const DuplicateQuoteContainer = ({ closeModal, quote }) => {
	const [loading, setLoading] = useState(false);

	const invoice = invoiceStore.selectedInvoice;
	const invoiceItem = invoice.status === constant.TRANSACTION_STATUS.UNPAID;

	const invoiceDetailsValidation = () => {
		return object({
			customer: string().required('Select a customer'),
			orders: array(
				object({
					quantity: number().min(1, 'Quantity should be greater than 1'),
					unitPrice: number().min(1, 'Unit price should be greater than 1'),
					item: string().required('Service is required'),
				})
			),
			vat: boolean().required('Are you charging VAT?'),
			wht: boolean().required('Are you deducting WHT?'),
			currencyCode: string().required('Select Currency'),
			dueDate: date().required('valid date is required'),
			discountPer: number()
				.default(0)
				.min(0, 'Min discount should be greater than 0%')
				.max(100, 'Max discount should be less than or equal to 100%'),
		});
	};

	const balanceAmount = values => {
		return totalAmountCal(values) - values.deposit;
	};

	const totalAmountCal = values =>
		totalWithoutDiscount(values) + values.shipping - values.discountAmount;

	const totalWithoutDiscount = values => {
		const totalItemPrice = values?.orders?.reduce(
			(previousValue, currentValue) =>
				previousValue + currentValue.quantity * currentValue.unitPrice,
			0
		);
		let totalAmount = totalItemPrice;
		totalAmount = values.vat ? totalAmount + totalAmount * 0.075 : totalAmount;
		totalAmount = values.wht ? totalAmount - totalAmount * 0.05 : totalAmount;
		return totalAmount;
	};

	const discountPerCal = values =>
		(values.discountAmount / totalWithoutDiscount(values)) * 100 || 0;

	const depositPerCal = values =>
		(values.deposit / totalAmountCal(values)) * 100 || 0;

	const depositAmountCal = values =>
		(values.depositPer * totalAmountCal(values)) / 100 || 0;

	const onSubmit = async values => {
		values.orders.forEach(item => {
			!item.stock && delete item.stock;
			delete item.itemPrice;
			delete item._id;
		});

		setLoading(true);
		const payload = {
			customer: values.customer,
			currencyCode: values.currencyCode,
			note: values.note,
			shipping: values.shipping,
			orders: values.orders,
			discountAmount: values.discountAmount,
			vat: values.vat,
			wht: values.wht,
			dueDate: values.dueDate,
		};

		const { status, errorMessage } = await QuotationController.createQuotation(
			payload,
			quote._id
		);
		setLoading(false);

		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			return;
		}
		MimaToastUtil.error({ message: errorMessage });
	};

	return (
		<DuplicateQuote
			quote={quote}
			invoice={invoice}
			invoiceItem={invoiceItem}
			depositAmountCal={depositAmountCal}
			discountPerCal={discountPerCal}
			depositPerCal={depositPerCal}
			balanceAmount={balanceAmount}
			onSubmit={onSubmit}
			invoiceDetailsValidation={invoiceDetailsValidation}
			loading={loading}
		/>
	);
};
export default observer(DuplicateQuoteContainer);
